export const extractValues = (obj: any, excludeKeys: string[] = []): string => {
    const values: string[] = [];

    const extract = (item: any, currentPath = '') => {
        if (item === null || item === undefined || typeof item === 'boolean') {
            return;
        }

        if (Array.isArray(item)) {
            if (item.length === 0) {
                return;
            }
            item.forEach((element) => {
                extract(element, currentPath);
            });
            return;
        }

        if (typeof item === 'object') {
            Object.keys(item).forEach(key => {
                const newPath = currentPath ? `${currentPath}.${key}` : key;
                if (!excludeKeys.includes(newPath)) {
                    extract(item[key], newPath);
                }
            });
            return;
        }

        values.push(String(item));
    };

    extract(obj);
    return values.join(' ');
};
